/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryByCategory extends models.InventorySummaryBase {
    getFixupPrototypeFunction() { return InventorySummaryByCategory.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryByCategory>): InventorySummaryByCategory {
        let obj = Object.assign(new InventorySummaryByCategory(), model);
        InventorySummaryByCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryByCategory>): InventorySummaryByCategory {
        if (!model) return null;
        return InventorySummaryByCategory.newInstance(<InventorySummaryByCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryByCategory) {
        if (!obj) return;

        models.InventorySummaryByCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryByCategory): boolean {
        if (models.InventorySummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InventorySummaryByCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_types) {
            for (let val of this.resource_types) {
                models.InventorySummaryByResourceType.fixupPrototype(val);
            }
        }
    }

    /**
     * Provider-native resource types this category owns, for example EC2 or Lambda, largest first
     */
    resource_types: Array<models.InventorySummaryByResourceType>;

}
